import { paramCase } from 'change-case'
import { oneOf, bool, string, func, array, object } from 'prop-types'
import { useState } from 'react'
import { kuiperClassNames } from '@opallabs/kuiper'
import { MobileSingle, DesktopSingle } from './displays'
import { baseStyles } from './styles'

const displays = {
  mobileSingle: MobileSingle,
  desktopSingle: DesktopSingle,
  default: MobileSingle,
}

const matchDisplay = (display) => displays[display] || displays.default

export const TikTokVideo = ({
  accountImage,
  accountName,
  assets,
  collabEnabled,
  collabAccount,
  display,
  isPresenting = false,
  isSnapshot = false,
  onExpandAsset,
  onRemoveAsset,
  content,
  readOnly,
  sound,
  truncate,
  updateText,
}) => {
  const RenderDisplay = matchDisplay(display)
  const video = assets[0] || null
  const [isHovered, setHovered] = useState(false)

  return (
    <div
      css={baseStyles({ display, hasAsset: Boolean(video) })}
      className={kuiperClassNames(
        'tiktok tiktok-video',
        `tiktok-${paramCase(display)}`
      )}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <RenderDisplay
        accountImage={accountImage}
        collabEnabled={collabEnabled}
        collabAccount={collabAccount}
        isPresenting={isPresenting}
        isSnapshot={isSnapshot}
        isHovered={isHovered}
        readOnly={readOnly}
        onContentChange={(val) => updateText(val, 'content')}
        onSoundChange={(val) => updateText(val, 'sound')}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        username={accountName}
        video={video}
        content={content}
        sound={sound}
        truncate={truncate}
      />
    </div>
  )
}

TikTokVideo.propTypes = {
  accountImage: object,
  accountName: string,
  accountUsername: string,
  assets: array,
  collabEnabled: bool,
  collabAccount: string,
  content: string,
  display: oneOf(['mobileSingle', 'desktopSingle']),
  isPresenting: bool,
  isSnapshot: bool,
  onExpandAsset: func,
  onRemoveAsset: func,
  readOnly: bool,
  sound: string,
  truncate: bool,
  updateText: func,
}
